import { render, staticRenderFns } from "./VacationConfirmWaitingDayLegend.vue?vue&type=template&id=af9369b6&"
import script from "./VacationConfirmWaitingDayLegend.vue?vue&type=script&lang=js&"
export * from "./VacationConfirmWaitingDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports